import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';

import { OverlayService } from '@shared/services/overlay.service';

import { RiskAlertDialogComponent } from './risk-alert-dialog/risk-alert-dialog.component';

export interface RiskCardAlert {
  color: string;
  message: string;
}
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass],
  selector: 'aux-risk-card',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  templateUrl: './risk-card.component.html',
})
export class RiskCardComponent {
  private overlayService = inject(OverlayService);

  @Input() alerts: RiskCardAlert[] = [];

  onManage() {
    this.overlayService.open({ content: RiskAlertDialogComponent });
  }
}
